import { Getrequest } from "./AxiosRequest";




const GetAdminCredentials = async (UserToken,accesstoken) => {
      

    const response = await Getrequest(`/auth/get_data_for_signle_admin/${UserToken}`,accesstoken)

    return response



}



export default GetAdminCredentials;